import GList_FiltersManager from "./filters-manager";
import GenericListModule from "../generic-list-module";
import {GlistFiletrs} from "../@types"

// this class knows current state for module (current filters)
// this class manages fields available for filtering
// this class DOES NOT filter !!!!

export default class GList_Filters {

    public module       : GenericListModule
    public manager      : GList_FiltersManager
    public _preFilters  : any

    constructor(module:GenericListModule, currentFilters:any, preFilters:any) {
        this.module = module

        this.manager = new GList_FiltersManager(module, currentFilters, this.onChange)

        this._preFilters = preFilters ? preFilters : {} // {fieldId: [values]} items filtering before filters manager processing (i.e. show/hide subfolders items)
    }

    values = () => {

        console.warn("CHECK ME 30489 - does it exist ? why erero")

        // @ts-ignore
        return this.manager.toObject();
    }
    onChange = () => {
        console.warn("CHECK ME 30488 - does it exist ? why erero")
        // @ts-ignore
        return this.module.onFiltersChanged()
    }

    setPrefilter = (filterId:string, values:any) => {
        this._preFilters[filterId] = values
        this.onChange()
    }

    removePrefilter = (filterId:string, values:any) => {
        delete this._preFilters[filterId]
        this.onChange()
    }

    get preFilters() {return this._preFilters}

    toJSON(): GlistFiletrs {
        return this.values()
    }
}
